import { useScript } from '#Root/ThirdPartyScriptLoader/useScript';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { useVwo } from 'hooks/useVwo';
import { carrotDomain } from 'utils/carrotDomain';
import { carrotEnvironment } from 'utils/carrotEnvironment';

const environment = carrotEnvironment(carrotDomain());
const facebookPixelId =
  environment === 'production' ? '792870337463321' : '190563102420564';
const ifsId = environment === 'production' ? 'az122' : 'dt143';

// Render base tracking scripts for everyone, logged out or logged in, except for super admins.
function BaseTrackingScripts({ children }: { children: React.ReactNode }) {
  const { isLoading, data } = useCurrentUser();

  return (
    <>
      {children}
      <div data-testid="create-account-base-scripts" className="hidden">
        {!isLoading && !data?.user?.superAdmin && <Scripts />}
      </div>
    </>
  );
}

function Scripts() {
  // We already have gtag loaded for Google Analytics, so we just need to
  // configure it for AdWords.
  useScript({
    id: 'adwords-configure',
    body: `gtag('config', 'AW-957567596');`,
  });

  useScript({
    id: 'facebook-pixel-base-code',
    body: `!function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${facebookPixelId}');
      fbq('track', 'PageView');`,
  });

  useVwo();

  // Keap / IFS / InfusionSoft tracking script
  useScript({
    id: 'keap-tracking-script',
    src: `https://${ifsId}.infusionsoft.com/app/webTracking/getTrackingCode?trackingId=2bc1bf41e97121c8b58bd73e8fd9cf35`,
  });

  return null;
}

export { BaseTrackingScripts };
